// src/pages/Home.jsx
import {NavLink} from "react-router-dom";
import TopBar from "../components/common/public/TopBar";
import ReadyToElevate from "../components/common/public/ReadyToElevate";
import PublicFooter from "../components/common/public/Footer";
import YouTubeCTA from "../components/youtube/YouTubeCTA";
import DownloadApp from "../components/common/public/DownloadApp";
import VideoSection from "../components/video/VideoSection";
import {GlobalStyles} from "../constants/styles";
import {useBranding} from "../context/BrandingContext";
import React from "react";
import useTranslation from "../i18n/useTranslation";

function Home() {
    const {theme} = useBranding(); // theme from BrandingContext (baseTheme on root)
    const {t, language} = useTranslation();

    return (
        <div
            style={{
                backgroundColor: GlobalStyles.colors.woodsmoke, // was "#14151a"
                color: GlobalStyles.colors.white,               // was "#ffffff"
                fontFamily: "'Poppins', sans-serif",
                overflowX: "hidden",
            }}
        >
            {/* Topbar with Logo */}
            <TopBar imgPath={theme.logo.main}/>

            <VideoSection
                key={language}
                src={`/videos/kbs-banner-${language}.mp4`}
                autoPlay
                loop
                muted
                align="center"
                maxWidth="1040px"
            />

            <div
                className="container"
                style={{
                    margin: "0 auto",
                    maxWidth: "1200px",
                    padding: "0 20px",
                }}
            >
                {/* Hero Section */}
                <div
                    className="jumbotron text-center p-5 rounded"
                    style={{
                        backgroundColor: GlobalStyles.colors.shark,   // was "#1f1f2e"
                        color: GlobalStyles.colors.canary,            // was "var(--kbs-primary, #00adff)"
                    }}
                >
                    <h1>{t('defaultHome.hero.title')}</h1>
                    <p
                        style={{color: GlobalStyles.colors.white}}   // was "#ffffff"
                        className="text-justify"
                    >
                        {t('defaultHome.hero.subtitle')}
                    </p>

                    {/* CTA buttons */}
                    <div
                        className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-3"
                        style={{gap: "12px"}}
                    >
                        {/* League / Org managers */}
                        <NavLink
                            to={"/register"}
                            className="btn btn-lg"
                            style={{
                                backgroundColor: GlobalStyles.colors.canary,   // was "var(--kbs-primary, #00adff)"
                                color: GlobalStyles.colors.kBolaBlue,          // was "var(--kbs-text-on-primary, #14151a)"
                                fontWeight: 600,
                                minWidth: "180px",
                            }}
                            end
                        >
                            {t('common.getStarted')}
                        </NavLink>

                        {/* Learn more scroll */}
                        <a
                            href="#features"
                            className="btn btn-lg"
                            style={{
                                borderColor: GlobalStyles.colors.canary,      // was "var(--kbs-primary, #00adff)"
                                color: GlobalStyles.colors.canary,
                                backgroundColor: "transparent",
                                fontWeight: 500,
                                minWidth: "160px",
                            }}
                        >
                            {t('common.learnMore')}
                        </a>
                    </div>
                </div>

                <YouTubeCTA/>

                {/*<VideoSection*/}
                {/*    key={language}*/}
                {/*    src={`/videos/kbs-banner-${language}.mp4`}*/}
                {/*    autoPlay*/}
                {/*    loop*/}
                {/*    muted*/}
                {/*    align="center"*/}
                {/*    maxWidth="1040px"*/}
                {/*/>*/}

                {/* Features Section */}
                <div id="features" className="mt-2">
                    <h2
                        className="text-center"
                        style={{color: GlobalStyles.colors.canary}}   // was "var(--kbs-primary, #00adff)"
                    >
                        {t('defaultHome.keyFeatures.title')}
                    </h2>
                    <div className="row">
                        {/* Smart Scheduling */}
                        <div className="col-md-4 text-center">
                            <div
                                className="card p-3"
                                style={{
                                    backgroundColor: GlobalStyles.colors.shark,   // was "#1f1f2e"
                                    color: GlobalStyles.colors.white,             // was "#ffffff"
                                    border: `1px solid ${GlobalStyles.colors.shark}`,
                                }}
                            >
                                <h5
                                    className="mt-3"
                                    style={{color: GlobalStyles.colors.canary}} // was "var(--kbs-primary, #00adff)"
                                >
                                    {t('defaultHome.keyFeatures.feature1.title')}
                                </h5>
                                <p>{t('defaultHome.keyFeatures.feature1.subtitle')}</p>
                                <img
                                    src="/dist/img/schedule.png"
                                    className="img-fluid"
                                    alt="Smart Scheduling"
                                />
                            </div>
                        </div>

                        {/* Performance Insights */}
                        <div className="col-md-4 text-center">
                            <div
                                className="card p-3"
                                style={{
                                    backgroundColor: GlobalStyles.colors.shark,
                                    color: GlobalStyles.colors.white,
                                    border: `1px solid ${GlobalStyles.colors.shark}`,
                                }}
                            >
                                <h5
                                    className="mt-3"
                                    style={{color: GlobalStyles.colors.canary}}
                                >
                                    {t('defaultHome.keyFeatures.feature2.title')}
                                </h5>
                                <p>{t('defaultHome.keyFeatures.feature2.subtitle')}</p>
                                <img
                                    src="/dist/img/stats.png"
                                    className="img-fluid"
                                    alt="Performance Insights"
                                />
                            </div>
                        </div>

                        {/* Results & Stats */}
                        <div className="col-md-4 text-center">
                            <div
                                className="card p-3"
                                style={{
                                    backgroundColor: GlobalStyles.colors.shark,
                                    color: GlobalStyles.colors.white,
                                    border: `1px solid ${GlobalStyles.colors.shark}`,
                                }}
                            >
                                <h5
                                    className="mt-3"
                                    style={{color: GlobalStyles.colors.canary}}
                                >
                                    {t('defaultHome.keyFeatures.feature3.title')}
                                </h5>
                                <p>{t('defaultHome.keyFeatures.feature3.subtitle')}</p>
                                <img
                                    src="/dist/img/results.png"
                                    className="img-fluid"
                                    alt="Results &amp; Stats"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* More Features with Screenshots */}
                <div className="row mt-5">
                    {/* Referee Rating */}
                    <div className="col-md-6 text-center">
                        <div
                            className="card p-3"
                            style={{
                                backgroundColor: GlobalStyles.colors.shark,
                                color: GlobalStyles.colors.white,
                                border: `1px solid ${GlobalStyles.colors.shark}`,
                            }}
                        >
                            <h5
                                className="mt-3"
                                style={{color: GlobalStyles.colors.canary}}
                            >
                                {t('defaultHome.keyFeatures.feature4.title')}
                            </h5>
                            <p>{t('defaultHome.keyFeatures.feature4.subtitle')}</p>
                            <img
                                src="/dist/img/rating.png"
                                className="img-fluid"
                                alt="Referee Rating"
                            />
                        </div>
                    </div>

                    {/* Connect */}
                    <div className="col-md-6 text-center">
                        <div
                            className="card p-3"
                            style={{
                                backgroundColor: GlobalStyles.colors.shark,
                                color: GlobalStyles.colors.white,
                                border: `1px solid ${GlobalStyles.colors.shark}`,
                            }}
                        >
                            <h5
                                className="mt-3"
                                style={{color: GlobalStyles.colors.canary}}
                            >
                                {t('defaultHome.keyFeatures.feature5.title')}
                            </h5>
                            <p>{t('defaultHome.keyFeatures.feature5.subtitle')}</p>
                            <img
                                src="/dist/img/marketplace.png"
                                className="img-fluid"
                                alt="Connect"
                            />
                        </div>
                    </div>
                </div>

                {/* Sponsor pitch / Advertise section */}
                <div className="row mt-5">
                    <div className="col-12">
                        <div
                            className="card p-4"
                            style={{
                                backgroundColor: GlobalStyles.colors.shark,      // was "#1f1f2e"
                                color: GlobalStyles.colors.white,
                                border: `1px solid ${GlobalStyles.colors.canary}`, // was "var(--kbs-primary, #00adff)"
                                borderRadius: "12px",
                            }}
                        >
                            <div className="row align-items-center">
                                <div className="col-md-8">
                                    <h4
                                        style={{
                                            color: GlobalStyles.colors.canary,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t('defaultHome.advertise.title')}
                                    </h4>
                                    <p style={{marginBottom: "8px"}}>
                                        {t('defaultHome.advertise.subtitle')}
                                    </p>
                                    <ul
                                        style={{
                                            paddingLeft: "1.2rem",
                                            marginBottom: "12px",
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        <li>{t('defaultHome.advertise.bullet1')}</li>
                                        <li>{t('defaultHome.advertise.bullet2')}</li>
                                        <li>{t('defaultHome.advertise.bullet3')}</li>
                                    </ul>
                                </div>
                                {/* CTA for advertising (kept commented) */}
                                <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <NavLink
                                        to="/advertising"
                                        className="btn btn-lg"
                                        style={{
                                            backgroundColor: GlobalStyles.colors.canary,
                                            color: GlobalStyles.colors.kBolaBlue,
                                            fontWeight: 600,
                                            minWidth: "200px",
                                            borderRadius: "8px",
                                        }}
                                    >
                                        {t('common.getStarted')}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Call to Action for leagues/managers */}
                <ReadyToElevate/>

                <DownloadApp/>
            </div>

            {/* Footer */}
            <PublicFooter imgPath={"/dist/img/"}/>
        </div>
    );
}

export default Home;
